import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatWorkOrderAmendmentStatusLabel } from '#/modules/momMgmt/workOrder/helper/amendmentStatus';

const WorkOrderAmendmentStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatWorkOrderAmendmentStatusLabel(status)}
    size={size}
    className={className}
  />
);

WorkOrderAmendmentStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default WorkOrderAmendmentStatusBadge;
